import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { FloatLabel } from "primereact/floatlabel";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import { Dropdown } from "primereact/dropdown";
import AdminMenu from "../../AdminMenu";
import { getBrandWhatsappConfig, getViewPromoTemplate, updatePromotion, viewPromotionCustomer } from "../../../services/PromoTemplate/PromoTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import PromoCustomerStatusFilterModal from "./PromoCustomerStatusFilterModal";
import { formatDateNew } from "../../../constants/DateUtil/DateUtil";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";

const { innerWidth: width, innerHeight: height } = window;

const PromoTemplateCustomerView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {}; // Fallback to prevent undefined errors
  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [promoTemplateList, setPromoTemplateList] = useState([]);
  const [brandWhatsappConfig, setBrandWhatsappConfig] = useState({});
  const [brandCustomers, setBrandCustomers] = useState([]);  
  const [selectionError, setSelectionError] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedOrderIds, setSelectedOrderIds] = useState([]);
  const [statusFilterModalVisible, setStatusFilterModalVisible] =
    useState(false);

  const minimumDate = new Date();
  minimumDate.setMonth(minimumDate.getMonth());

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3);

  const [page, setPage] = useState(0); // current page
  const [totalPages, setTotalPages] = useState(1);
  const [useEffectCall, setUseEffectCall] = useState(false);

  const handleFilterModal = () => {
    setStatusFilterModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };

  const [selectedStatus, setSelectedStatus] = useState("ALL"); // Default to show all orders

  const receiveDataFromStatusFilterModal = (selectedStatus) => {
    setUseEffectCall(true);
    setPage(0);
    setSelectedStatus(selectedStatus);
  };

  const fetchPromoTemplate = () => {
    getBrandWhatsappConfig(brandId)
      .then((response) => {
        if (!response.data.error) {
          const config = response.data;
          setBrandWhatsappConfig(config);
          const data = {
            statusIn: ["REGISTER", "SENDING", "SENT", "DELIVERED", "READ", "FAILED"]
          };

          // initial load (offset = 0)
          if (config?.whatsappPromoLimit > 0) {
            setPage(0);
            fetchBrandCustomers(0, data, config?.whatsappPromoLimit);
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    getViewPromoTemplate(brandId)
      .then((response) => {
        if (!response.data.error) {
          setPromoTemplateList(response.data);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const data = {
    statusIn: ["REGISTER", "SENDING", "SENT", "DELIVERED", "READ", "FAILED"]
  };

  const [requestData, setRequestData] = useState(data);


  useEffect(() => {
    fetchPromoTemplate();
  }, []);

  const [customerALLOrdersData, setCustomerALLOrdersData] = useState([])

    const [searchTerm, setSearchTerm] = useState("");

    

  const filterPromotionList = () => {
    return customerALLOrdersData.filter((item) => {
      const search = searchTerm.toLowerCase();

      const templateName = item?.customerName?.toLowerCase() || "";
      const templateNumber =
        item?.mobile?.toLowerCase() || "";

      return (
        templateName.includes(search) ||
        templateNumber.includes(search)
      );
    });
  };

  const filteredPromotionData = filterPromotionList();
  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const fetchBrandCustomers = (pageNumber = 0, requestData, limit) => {

    // const limit = brandWhatsappConfig?.whatsappPromoLimit;
    

    const data = {
      ...requestData,
      promotionId: item?.id,
      limit,
      offset: pageNumber * limit,
      
    };

    viewPromotionCustomer(data)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data || [];

          // 🔥 Replace old data
          setBrandCustomers(res);
          if (pageNumber === 0) {
            setCustomerALLOrdersData(res); // Reset state with new data
            // updateStatusTotals(res); // Calculate totals based on the fresh data
          } else {
            setCustomerALLOrdersData((prevData) => [...prevData, ...res]);
            // updateStatusTotals([...customerALLOrdersData, ...res]); // Calculate totals including additional data
          }

          // 🔥 Calculate pages dynamically
          if (res.length === limit) {
            setTotalPages((prev) => Math.max(prev, pageNumber + 2));
          } else {
            setTotalPages(pageNumber + 1);
          }
        }
      })
      .catch((err) => console.error(err));
  };


  useEffect(() => {
    if (useEffectCall) {
      if (selectedStatus !== "ALL") {
        requestData.statusIn = selectedStatus;
      } else {
        requestData.statusIn = ["REGISTER", "SENDING", "SENT", "DELIVERED", "READ", "FAILED"];
      }

      if(brandWhatsappConfig?.whatsappPromoLimit > 0 ){
        fetchBrandCustomers(page, requestData, brandWhatsappConfig?.whatsappPromoLimit);
      }
    }
  }, [selectedStatus]);



  const handlePageChange = (pageNumber) => {
    if(brandWhatsappConfig?.whatsappPromoLimit > 0 ) {
      setPage(pageNumber);
      fetchBrandCustomers(pageNumber, requestData, brandWhatsappConfig?.whatsappPromoLimit);
    }
  };


  const [promoTemplate, setPromoTemplate] = useState("")

  useEffect(() => {
    if (item?.id) {
      setPromoTemplate(item?.brandPromoTemplate)
    }
  }, [item]);

  const [promoTemplateError, setPromoTemplateError] = useState("");

  const handleConfirmAndContinue = () => {
    setModalMenuVisible(true);
  };

  const handlePromoTemplateChange = (selectedItem) => {
    setPromoTemplate(selectedItem)
  };
   
  const handleSelectionChange = (e) => {
    const whatsappLimit = brandWhatsappConfig?.whatsappPromoLimit || 0;
    const promoLeft = brandWhatsappConfig?.promoLeftCount ?? whatsappLimit;

    // ✅ Determine actual allowed limit
    const effectiveLimit =
      promoLeft < whatsappLimit ? promoLeft : whatsappLimit;

    const selected = e.value || [];

    // ❌ If exceeding effective limit
    if (effectiveLimit && selected.length > effectiveLimit) {
      setSelectionError(
        promoLeft < whatsappLimit
          ? `Only ${promoLeft} promotions left.`
          : `You can select a maximum of ${whatsappLimit} customers.`
      );

      // ✅ Keep only allowed selections
      const trimmedSelection = selected.slice(0, effectiveLimit);

      setSelectedRows(trimmedSelection);
      setSelectedOrderIds(trimmedSelection.map((row) => row.id));
      return;
    }

    // ✅ Valid selection
    setSelectionError("");
    setSelectedRows(selected);
    setSelectedOrderIds(selected.map((row) => row.id));
  };

const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      // Map only the required fields for export
      const exportData = filteredPromotionData.map((item) => ({
         
        "Promo Template Name": promoTemplate?.templateName,
        "Created On": formatDateNew(item.createdDate),
        "Customer Name": item.customerName?.replace(/_/g, " "),
        Mobile: item.mobile,
        Status: item.status?.replace(/_/g, " "),
      }));

      const worksheet = xlsx.utils.json_to_sheet(exportData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, promoTemplate?.templateName);
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };

  const customerNameTemplate = (rowData) => {
    return (
      <div>
        <p>
          {[
            rowData?.customerName,
          ]
            .filter(
              (name) =>
                name &&
                name !== "null" &&
                name !== "undefined"
            )
            .join(" ")}
        </p>
      </div>
    );
  };


  const RenderTabView = () => {
    return (
      <DataTable
        lazy
        paginator
        rows={brandWhatsappConfig?.whatsappPromoLimit}
        // totalRecords={totalCount}
        onPage={(e) => handlePageChange(e.page)}
        showGridlines
        value={filteredPromotionData}
        // header={header}
        rowsPerPageOptions={[50, 75, 100]}
        tableStyle={{ minWidth: "120px" }}
        stripedRows
        selectionMode="checkbox"
        selection={selectedRows}
        onSelectionChange={handleSelectionChange}
      >
      <Column
                header="S No."
                style={{ width: "80px" }}
                body={(rowData, options) =>
                  options.rowIndex + 1}
              ></Column>
        {/*<Column
          field="customerName"
          header="Customer Name"
          style={{ width: "60px" }}
          body={customerNameTemplate}
        ></Column>*/}

        <Column
          field="mobile"
          header="Mobile"
          style={{ width: "60px" }}
          body={(rowData) => rowData?.mobile}
        ></Column>
        <Column
          field="status"
          header="Status"
          style={{ width: "60px" }}
          body={(rowData) => rowData?.status}
        ></Column>
      </DataTable>
    );
  };


  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/PromoTemplateView")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Promo Template Customer View
              </p>
            </div>
          </div>

          <div className="flex justify-content-center align-items-center">
            <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
              <img
                onClick={exportExcel}
                src={"images/file.png"}
                style={{
                  width: 30,
                }}
              />
            </div>
          </div>
          <div
            onClick={() => handleFilterModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: 27 }}
            />
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <Dropdown
              id="promoTemplate"
              value={promoTemplate}
              onChange={(e) => handlePromoTemplateChange(e.target.value)}
              options={promoTemplateList}
              optionLabel="templateName"
              placeholder="Promo Template"
              disabled={true}
              className="w-full border-round-xl  text-2xl text-xl shadow-2"
            />
            {promoTemplateError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {promoTemplateError}
              </p>
            )}
            <label
              htmlFor="promoTemplate"
              className="text-md"
              style={{ color: "blue" }}
            >
              Promo Template <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>

      <div className="my-2 mx-4 flex flex-1">
              <div className="flex-1">
                <IconField iconPosition="left" className="flex flex-1">
                  <InputIcon className="pi pi-search text-xl"> </InputIcon>
                  <InputText
                    placeholder={
                      "Search Customer Name or Mobile Number Here"
                    }
                    value={searchTerm}
                    keyboardType={
                      "default"
                    }
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="text-xl flex flex-1 py-1 px-5"
                    style={{ borderRadius: 30 }}
                  />
                </IconField>
              </div>
      
              {searchTerm && (
                <div
                  className="flex justify-content-center align-items-center mx-2 cursor-pointer"
                  onClick={handleClearSearch}
                >
                  <p className="text-3xl font-bold " style={{ color: "red" }}>
                    X
                  </p>
                </div>
              )}
            </div>

      <div>
        <div>
          <p className="font-bold block mb-2 ml-2">Customer Info</p>
          <div
            className="scroll-bar mb-2"
            style={{
              height: height > 600 ? 380 : 320,
              overflowY: "scroll",
            }}
          >
            <div className="mx-4 report-table">
              <div className="tab-view-table">{RenderTabView()}</div>
            </div>
          </div>
          <div className="flex justify-content-center gap-2 my-3">
            {Array.from({ length: totalPages }).map((_, index) => (
              <Button
                key={index}
                label={(index + 1).toString()}
                onClick={() => handlePageChange(index)}
                className={page === index ? "p-button" : "p-button-outlined"}
              />
            ))}
          </div>
        </div>
        {selectionError && (
          <p className="text-lg font-normal text-center mt-2" style={{ color: "red" }}>
            {selectionError}
          </p>
        )}
      </div>

      

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <PromoCustomerStatusFilterModal
        setStatusFilterModalVisible={setStatusFilterModalVisible}
        statusFilterModalVisible={statusFilterModalVisible}
        sendDataToOrdersPageFromFilter={receiveDataFromStatusFilterModal}
        OrderStatus={["REGISTER", "SENDING", "SENT", "DELIVERED", "READ","FAILED"]}
      />


      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default PromoTemplateCustomerView;
